var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPeopleIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 17,
    viewBox: "0 0 17 17",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.35013 1.7002C2.26123 1.75346 1.94556 3.89537 2.56549 6.35527C2.44536 6.42441 2.24779 6.64386 2.29766 7.03372C2.39059 7.76076 2.70578 7.94479 2.90638 7.96009C2.98288 8.63896 3.71167 9.50716 3.96667 9.63353V10.7669C3.4 12.4669 0 10.7669 0 15.3002H6.8C6.8 13.2897 7.92735 12.4238 8.86745 11.9257C7.98458 11.6163 7.0703 11.5778 6.8 10.7669V9.63353C7.055 9.50716 7.78322 8.6395 7.86029 7.9612C7.90562 7.80083 7.94108 7.22712 7.94108 7.09792C7.94108 6.39015 7.93069 4.92726 8.37383 3.78203C8.21913 3.0125 7.81474 2.3635 6.94831 2.27793C6.71654 1.8943 6.1225 1.7002 5.35013 1.7002ZM12.5364 2.26686C11.8995 2.26686 11.4075 2.83353 11.4075 2.83353C7.75702 2.83353 9.78353 9.04042 8.71139 9.93236C8.71139 9.93236 9.28143 10.7768 11.3333 10.7768V11.4995C10.7667 13.0335 7.93333 12.4669 7.93333 15.3002H17C17 12.4669 14.1667 13.0335 13.6 11.4995V10.7702C15.6621 10.7702 16.14 9.95339 16.14 9.95339C14.9857 9.00592 16.9995 2.26686 12.5364 2.26686Z",
    fill: "#555770"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeopleIcon);
export default __webpack_public_path__ + "static/media/peopleIcon.ef4f040e0d17c7c0033eed136d8f0c0b.svg";
export { ForwardRef as ReactComponent };